module.exports = __webpack_public_path__ + "static/media/img_stp_card_amex.45482995.png";